import { render } from "./ClientConfigTab.vue?vue&type=template&id=d0648f0c"
import script from "./ClientConfigTab.vue?vue&type=script&lang=js"
export * from "./ClientConfigTab.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__